// extracted by mini-css-extract-plugin
export default {"tag":"Style_tag__Ym+XN","value":"Style_value__v+RNV","remove":"Style_remove__7qHm4","closeTag":"Style_closeTag__GZgw6","slide-in-bottom":"Style_slide-in-bottom__xZqLD"};